export default __webpack_public_path__ + "static/media/ferrum-footer-logo.c4029197.svg";